\rtr-short-article
    max-width: 100%
